/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute exact path='/catalog'>.
 * Внутри Catalog — вложенный Switch ('/catalog/' → CatalogMain,
 * '/catalog/bar' → CatalogBar, ...): работает через универсальные
 * Route/Switch compat-слоя.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Catalog from '@routes/Catalog/component';

export const Route = createFileRoute('/catalog/')({
  component: () => <CacheDataRoute component={Catalog} path='/catalog' />
});
